type RecurringPricing = {
  entry?: number
  installmentValue?: number
  installments?: number
  total?: number
  recorrente?: boolean
} | null | undefined

/** Implantação só vale quando entra por cima da mensalidade. Se o total já é parcelas × mensal, a entrada repetida é a própria mensalidade. */
export function recurringSetupEntry(pricing: RecurringPricing): number {
  const entry = Number(pricing?.entry || 0)
  if (!(entry > 0) || !pricing?.recorrente) return entry > 0 ? entry : 0
  const monthly = Number(pricing.installmentValue || 0)
  const months = Number(pricing.installments || 0)
  if (!(monthly > 0) || !(months > 0)) return entry
  const schedule = monthly * months
  const total = Number(pricing.total || 0)
  if (total > 0 && total <= schedule * 1.001) return 0
  return entry
}

export function normalizeItemSetupEntry<T extends { pricing?: RecurringPricing }>(item: T): T {
  if (!item.pricing?.recorrente) return item
  const entry = recurringSetupEntry(item.pricing)
  if (entry === Number(item.pricing.entry || 0)) return item
  return { ...item, pricing: { ...item.pricing, entry } }
}
